import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

export default new Router({
    mode: 'hash',
    base: '/qbot',
    routes: [
        {
            path: '/chat/:id?',
            name: 'Chat',
            component: r => require.ensure([], () => r(require('@/pages/chat/main.vue')), 'Chat')
        },
        {
            path: '/workbench',
            name: 'Workbench',
            component: r => require.ensure([], () => r(require('@/pages/workbench/main.vue')), 'Workbench')
        },
        {
            path: '/user',
            name: 'User',
            component: r => require.ensure([], () => r(require('@/pages/user/main.vue')), 'User')
        }
    ]
});



// WEBPACK FOOTER //
// ./src/router/index.js